"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferERC20Step = void 0;
const token_1 = require("../../../utils/token");
const step_1 = require("../../step");
const contract_1 = require("../../../contract");
class TransferERC20Step extends step_1.Step {
    config = {
        name: 'Transfer ERC20',
        description: 'Transfers ERC20 token to an external public address.',
    };
    toAddress;
    erc20Info;
    amount;
    constructor(toAddress, erc20Info, amount) {
        super();
        this.toAddress = toAddress;
        this.erc20Info = erc20Info;
        this.amount = amount;
    }
    async getStepOutput(input) {
        const { erc20Amounts } = input;
        const { erc20AmountForStep, unusedERC20Amounts } = this.getValidInputERC20Amount(erc20Amounts, erc20Amount => (0, token_1.compareERC20Info)(erc20Amount, this.erc20Info), this.amount);
        const contract = new contract_1.RelayAdaptContract(input.networkName);
        const crossContractCalls = [
            await contract.createERC20Transfer(this.toAddress, this.erc20Info.tokenAddress, this.amount),
        ];
        const transferredERC20 = {
            tokenAddress: this.erc20Info.tokenAddress,
            decimals: this.erc20Info.decimals,
            amount: this.amount ?? erc20AmountForStep.expectedBalance,
            recipient: this.toAddress,
        };
        return {
            crossContractCalls,
            spentERC20Amounts: [transferredERC20],
            outputERC20Amounts: unusedERC20Amounts,
            outputNFTs: input.nfts,
        };
    }
}
exports.TransferERC20Step = TransferERC20Step;
